import React from 'react';
import { IconButton, makeStyles, Theme } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import { StyledText } from './StyledText';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: 5,
    backgroundColor: 'rgba(1,1,1,0)',
    borderColor: theme.palette.border.main,
    '&:hover': {
      backgroundColor: 'rgba(1,1,1,0)',
      borderColor: 'rgba(1,1,1,0)'
    },
    '&:hover *': {
      color: theme.palette.secondary.dark
    }
  },
  '& svg': {
    color: theme.palette.secondary.main,
    margin: '0px'
  },
  exportPrompt: {
    cursor: 'pointer',
    color: `${theme.palette.secondary.main}`
  }
}));

interface AddButtonProps {
  onClick?: (args: any) => void
  style?: React.CSSProperties
}

const AddButton: React.FC<AddButtonProps> = (props) => {
  const { onClick, style } = props;
  const styles = useStyles();
  return (
    <IconButton type='button' onClick={onClick} className={styles.root} disableFocusRipple disableRipple style={style}>
      <StyledText className={styles.exportPrompt} variant='h3'> Export to CSV </StyledText>
      <DownloadIcon color='secondary' />
    </IconButton>
  );
};

export default AddButton;
